export default __webpack_public_path__ + "static/media/KingTut.767cafb3.mov";